export default "__VITE_ASSET__BxuiVsPV__"